import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { GlobalComponentService } from '@techmore/global';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { UploadService } from 'src/app/share/service/upload.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { SubjectTemplateService } from '../../../service/subject-template.service';
import { SubjectBanner01Component } from '../../subject-template-01/subject-banner01/subject-banner01.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-subject-banner02',
  templateUrl: './subject-banner02.component.html',
  styleUrls: [
    '../../subject-template-01/subject-banner01/subject-banner-editor.component.scss',
    '../../subject-template-01/subject-banner01/subject-banner01.component.scss',
    './subject-banner02.component.scss'
  ]
})
export class SubjectBanner02Component extends SubjectBanner01Component implements OnInit {
  constructor(
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected commonHttp: CommonHttpClientService,
    serverConfigService: ServerConfigService,
    protected globalComponentService: GlobalComponentService,
    protected uploadService: UploadService,
    protected subjectTemplateService: SubjectTemplateService,
    protected translate: TranslateService,
  ) {
    super(generatorEnv, platformId, commonHttp, serverConfigService, globalComponentService, uploadService, subjectTemplateService, translate);
  }
}
